export * from './match-category-candidate.component';
